import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { Es01AppRoutingModule } from './es01-app-routing.module';
import { Es01AppComponent } from './es01-app.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { metaReducers, reducers } from '../../reducers';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { authInterceptor } from '../../auth/interceptors/auth.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { A11yModule } from '@angular/cdk/a11y';
import { UserFlowStore } from '../../core/store/user-flow.store';
import { StartFlowModule } from '../../start-flow/start-flow.module';
import { KeycloakDynamicAuthModule } from 'src/app/auth/providers/keycloak/keycloak-dynamic-auth.module';
import { provideNoOpModalController } from '../../core/providers/no-op-modal-controller.provider';

@NgModule({
  declarations: [Es01AppComponent],
  bootstrap: [Es01AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    A11yModule,
    EffectsModule.forRoot([]),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    environment.reduxToolsEnabled
      ? StoreDevtoolsModule.instrument({
          maxAge: environment.reduxMaxAge,
          logOnly: environment.production,
          serialize: true,
          connectInZone: true,
        })
      : [],
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    StoreRouterConnectingModule.forRoot(),
    Es01AppRoutingModule,
    KeycloakDynamicAuthModule.forRoot(),
    StartFlowModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    UserFlowStore,
    provideNoOpModalController(),
  ],
})
export class Es01AppModule {}
